import {
  NoAdsBookmarksDark,
  NoAdsBookmarksLight
} from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from '../NoAds.styles';
import { Props } from '../NoAds.types';

export const NoAdsBookmark: Props = ({ t, isDark }) => {
  const icon = isDark ? <NoAdsBookmarksDark /> : <NoAdsBookmarksLight />;

  return (
    <S.NoAdsWrapper $paddingTop="80px" data-testid="no-ads-result">
      <S.IllustrationWrapper>{icon}</S.IllustrationWrapper>
      <S.TextWrapper>
        <Typography variant="h0">{t('NoAds.bookmarks.title')}</Typography>
        <Typography variant="body2">{t('NoAds.bookmarks.subtitle')}</Typography>
      </S.TextWrapper>
    </S.NoAdsWrapper>
  );
};
